/* A separator belongs between links on the same visual row. */
(() => {
  if (window.relatedNavigationRows) return;
  window.relatedNavigationRows = true;
  const selector = '.related-navigation__links, .cd2-nav, .eg2-nav';
  const observed = new WeakSet();
  const update = nav => {
    let previousTop;
    for (const link of nav.children) {
      const top = link.offsetTop;
      link.toggleAttribute('data-row-start', previousTop === undefined || Math.abs(top - previousTop) > 1);
      previousTop = top;
    }
  };
  const observer = new ResizeObserver(entries => entries.forEach(entry => update(entry.target)));
  const init = () => document.querySelectorAll(selector).forEach(nav => {
    if (!observed.has(nav)) { observed.add(nav); observer.observe(nav); }
    update(nav);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
  document.fonts.ready.then(init);
})();
